<template>
  <div id="app">
    <div style="margin-bottom: 40px">
      <b-form @submit="onSearch" @keyup.enter="onSearch" inline>
        <b-form-input
          ref="search"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="Reference code or name"
          style="width: 200px"
        />
        <b-button type="submit" variant="primary">Search</b-button>
        <div style="margin-left: 20px">
          {{ search_total }} / {{ total }} registrations
        </div>
        <b-icon
          icon="arrow-clockwise"
          font-scale="1"
          style="margin-left: 10px"
          role="button"
          @click="onReload"
        ></b-icon>
      </b-form>
    </div>

    <b-container>
      <b-row>
        <b-col>
          <b-pagination-nav
            size="sm"
            align="fill"
            v-model="current_page"
            :number-of-pages="total_page"
            base-url="#"
            first-number
            last-number
            @change="onPageChanged"
          ></b-pagination-nav>
        </b-col>
      </b-row>
      <b-row>
        <b-table striped hover :items="queriedRecords"></b-table>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination-nav
            size="sm"
            align="fill"
            v-model="current_page"
            :number-of-pages="total_page"
            base-url="#"
            first-number
            last-number
            @change="onPageChanged"
          ></b-pagination-nav>
        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="modal-progress" block hide-footer hide-header>
      <p class="my-4">Wait a minute......</p>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase";

const config = {
  apiKey: "AIzaSyAeIocDhvjAxfC397tOPp5eW3G1M2qCkOg",
  authDomain: "eventpop-registration-develop.firebaseapp.com",
  projectId: "eventpop-registration-develop",
  appId: "1:335920685449:web:548a6f86618bded9b18158",
};

firebase.initializeApp(config);

let database = firebase.firestore();
let recordsRef = database.collection("events").doc("GMM-23");

export default {
  name: "app",
  data() {
    return {
      records: {},
      queriedRecords: {},
      total: 0,
      search_total: 0,
      current_page: 1,
      total_page: 1,
      MAX_PAGE: 100,
    };
  },
  created() {
    firebase
      .auth()
      .signInWithEmailAndPassword("dashboard@eventpop.me", "DASHBOARD")
      .catch((error) => {
        console.log(error);
      });
  },
  async mounted() {
    this.$refs["modal-progress"].show();

    const snapshot = await recordsRef.collection("registrations").orderBy('uuid').get();
    this.records = [];

    snapshot.forEach((data) => {
      let record = {
        uuid: data.data().uuid,
        name: data.data().firstname + " " + data.data().lastname,
        reference_code: data.data().reference_code,
        email: data.data().email,
        phone: data.data().mobilephone,
        birthyear: data.data().birthyear,
        gender: data.data().gender,
        province: data.data().province,
        ticket_type: data.data().ticket_type,
        registered_at: new Date(
          parseInt(data.data().timestamp)
        ).toLocaleString(),
      };

      if (data.data().checkin_activity) {
        let entries = Object.entries(data.data().checkin_activity);

        for (var i = 0; i < entries.length; ++i) {
          if (entries[i][0] == "timestamp") {
            record.checkedin_at = new Date(
              parseInt(entries[i][1])
            ).toLocaleString();
          } else if (entries[i][0] == "gate_id") {
            record.gate_id = entries[i][1];
          }
        }
      }

      this.records.push(record);
    });

    this.queriedRecords = this.records.slice(0, this.MAX_PAGE);

    this.total = this.records.length;
    this.search_total = this.total;
    this.total_page = this.total / this.MAX_PAGE;

    this.$refs["modal-progress"].hide();
  },
  methods: {
    onSearch(evt) {
      evt.preventDefault();

      let search = this.$refs.search.localValue.toLowerCase();

      let result = this.records.filter((record) => {
        return (
          record.reference_code.toLowerCase().includes(search) ||
          record.name.toLowerCase().includes(search)
        );
      });

      this.current_page = 1;
      this.total_page = result.length / this.MAX_PAGE;
      this.queriedRecords = result.slice(0, this.MAX_PAGE);

      this.search_total = result.length;
    },
    onPageChanged(page) {
      let search = this.$refs.search.localValue.toLowerCase();

      let result = this.records.filter((record) => {
        return (
          record.ref_code.toLowerCase().includes(search) ||
          record.name.toLowerCase().includes(search)
        );
      });

      let start = (page - 1) * this.MAX_PAGE;
      this.queriedRecords = result.slice(start, start + this.MAX_PAGE);
    },
    onReload() {
      location.reload();
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 60px;
}
</style>
